import HumanPage from './HumanPage';
import Form from './form/Form';
import Entries from '../shared/entries/Entries';
import Horses from './horses/Horses';
import Stats from './stats/Stats';
import PageProvider from '../shared/providers/PageProvider';
import TabFetchProvider from '../shared/providers/TabFetchProvider';
import TabProvider from '../shared/providers/TabProvider';

const humans = ['jockey', 'trainer', 'owner'];

const routes = humans.map(human => ({
    path: `${human}/:id/:name`,
    component: PageProvider,
    Page: HumanPage,
    indexRoute: {
        component: TabProvider,
        Tab: Form,
    },
    childRoutes: [
        {
            path: 'form',
            component: TabProvider,
            Tab: Form,
        },
        {
            path: human === 'jockey'
                ? 'booked-rides' : 'entries',
            component: TabProvider,
            Tab: Entries,
        },
        {
            path: 'horses',
            component: TabFetchProvider,
            Tab: Horses,
        },
        {
            path: 'stats',
            component: TabFetchProvider,
            Tab: Stats,
        },
    ],
}));

export default routes;



// WEBPACK FOOTER //
// ./src/js/human/humanRoutes.js